// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1vdtE","image":"hero-module--image--3ByPD","writing":"hero-module--writing--1DGXF"};